// Hadatha i18n — English + Kiswahili
export type Language = 'en' | 'sw';

export const SUPPORTED_LANGUAGES: { code: Language; label: string; flag: string }[] = [
  { code: 'en', label: 'English', flag: '🇬🇧' },
  { code: 'sw', label: 'Kiswahili', flag: '🇹🇿' },
];

const en = {
  nav: {
    home: 'Home',
    music: 'Music',
    videos: 'Videos',
    gallery: 'Gallery',
    events: 'Events',
    news: 'News',
    about: 'About',
    booking: 'Book Now',
    press: 'Press',
    epk: 'EPK',
    search: 'Search',
    fans: 'Fan Zone',
  },
  home: {
    heroTitle: 'HADATHA',
    heroSubtitle: 'Tanzanian Artist',
    heroCtaBook: 'Book Now',
    heroCtaMusic: 'Listen Now',
    featuredReleases: 'Featured Releases',
    upcomingEvents: 'Upcoming Events',
    latestNews: 'Latest News',
    streamOn: 'Stream on',
    viewAll: 'View All',
    noEvents: 'No upcoming events at this time.',
    noNews: 'No news articles yet.',
  },
  about: {
    title: 'About Hadatha',
    subtitle: 'The White Lioness',
    bio: 'Artist Biography',
    origin: 'Origin',
    genre: 'Genre',
    contact: 'Get in Touch',
  },
  music: {
    title: 'Music',
    subtitle: 'Discography & Releases',
    allReleases: 'All Releases',
    singles: 'Singles',
    albums: 'Albums',
    eps: 'EPs',
    streamOn: 'Stream on',
    noMusic: 'No music releases yet.',
    listenOn: 'Listen on',
  },
  events: {
    title: 'Events',
    subtitle: 'Live Performances',
    upcoming: 'Upcoming',
    past: 'Past Events',
    getTickets: 'Get Tickets',
    noUpcoming: 'No upcoming events at this time.',
    noPast: 'No past events.',
    venue: 'Venue',
    date: 'Date',
    time: 'Time',
  },
  news: {
    title: 'News',
    subtitle: 'Latest Updates',
    readMore: 'Read More',
    noNews: 'No news articles yet.',
    category: 'Category',
    publishedOn: 'Published on',
    by: 'by',
  },
  booking: {
    title: 'Book Hadatha',
    subtitle: 'Submit a booking inquiry',
    name: 'Full Name',
    email: 'Email Address',
    phone: 'Phone Number',
    country: 'Country',
    eventType: 'Event Type',
    eventDate: 'Event Date',
    venue: 'Venue',
    budget: 'Budget',
    message: 'Message',
    submit: 'Submit Inquiry',
    submitting: 'Submitting...',
    success: 'Your booking inquiry has been submitted. We will contact you within 24 hours.',
    error: 'Failed to submit. Please try again.',
    required: 'This field is required.',
    invalidEmail: 'Please enter a valid email address.',
    guestCount: 'Expected Guests',
    accommodation: 'Accommodation Required',
    transport: 'Transport Required',
    technicalReqs: 'Technical Requirements',
    performanceDuration: 'Performance Duration',
  },
  contact: {
    title: 'Contact',
    subtitle: 'Get in Touch',
    email: 'Email',
    phone: 'Phone',
    forBookings: 'For Bookings',
    forPress: 'For Press',
    sendMessage: 'Send Message',
    yourName: 'Your Name',
    yourEmail: 'Your Email',
    subject: 'Subject',
    yourMessage: 'Your Message',
    send: 'Send',
    sending: 'Sending...',
    sent: 'Message sent successfully.',
    failed: 'Failed to send. Please try again.',
  },
  gallery: {
    title: 'Gallery',
    subtitle: 'Photos & Media',
    all: 'All',
    noImages: 'No gallery images yet.',
  },
  videos: {
    title: 'Videos',
    subtitle: 'Music Videos & Performances',
    watchOn: 'Watch on YouTube',
    noVideos: 'No videos yet.',
  },
  press: {
    title: 'Press Center',
    subtitle: 'Media Coverage & Press Releases',
    pressReleases: 'Press Releases',
    mediaCoverage: 'Media Coverage',
    downloadPdf: 'Download PDF',
    readArticle: 'Read Article',
    pressInquiries: 'Press Inquiries',
    noPress: 'No press items published yet.',
  },
  epk: {
    title: 'Electronic Press Kit',
    subtitle: 'Official EPK',
    biography: 'Artist Biography',
    shortBio: 'Short Bio',
    music: 'Music',
    videos: 'Videos',
    achievements: 'Achievements',
    pressQuotes: 'Press Quotes',
    booking: 'Booking',
    streaming: 'Streaming & Social',
    downloadEpk: 'Download EPK (PDF)',
    notPublished: 'EPK not available yet.',
  },
  fans: {
    title: 'Fan Zone',
    subtitle: 'Join the Hadatha Community',
    register: 'Create Account',
    login: 'Sign In',
    logout: 'Sign Out',
    email: 'Email Address',
    password: 'Password',
    displayName: 'Display Name',
    confirmPassword: 'Confirm Password',
    alreadyHaveAccount: 'Already have an account?',
    noAccount: "Don\'t have an account?",
    favorites: 'My Favorites',
    noFavorites: 'No favorites yet.',
    welcome: 'Welcome',
    registerSuccess: 'Account created successfully.',
    loginSuccess: 'Signed in successfully.',
    logoutSuccess: 'Signed out.',
  },
  footer: {
    contact: 'Contact',
    email: 'info@hadathatz.com',
    phone: '+255 718 863 913',
    rights: 'All rights reserved.',
    newsletter: 'Subscribe to Newsletter',
    newsletterPlaceholder: 'Your email address',
    subscribe: 'Subscribe',
    quickLinks: 'Quick Links',
    followUs: 'Follow Us',
    streamMusic: 'Stream Music',
    privacyPolicy: 'Privacy Policy',
    terms: 'Terms of Use',
  },
  search: {
    title: 'Search',
    placeholder: 'Search music, news, events, videos, press...',
    button: 'Search',
    noResults: 'No results found',
    results: 'results for',
    filters: {
      all: 'All',
      music: 'Music',
      news: 'News',
      events: 'Events',
      gallery: 'Gallery',
      videos: 'Videos',
      press: 'Press',
    },
  },
  common: {
    loading: 'Loading...',
    error: 'Something went wrong.',
    readMore: 'Read More',
    learnMore: 'Learn More',
    close: 'Close',
    back: 'Back',
    next: 'Next',
    previous: 'Previous',
    share: 'Share',
    download: 'Download',
    publish: 'Publish',
    draft: 'Draft',
    published: 'Published',
    save: 'Save',
    cancel: 'Cancel',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    update: 'Update',
    viewAll: 'View All',
    noData: 'No data available.',
    required: 'Required',
    optional: 'Optional',
  },
  seo: {
    homeTitle: 'Hadatha — Official Artist Platform | The White Lioness',
    homeDesc: 'Official platform for Hadatha (Ester Edson), Tanzanian Afro & Contemporary African music artist.',
    musicTitle: 'Music — Hadatha',
    musicDesc: 'Stream and discover music by Hadatha on Spotify, Apple Music, YouTube, and SoundCloud.',
    eventsTitle: 'Events — Hadatha',
    eventsDesc: 'Upcoming live performances and events by Hadatha.',
    newsTitle: 'News — Hadatha',
    newsDesc: 'Latest news, updates, and announcements from Hadatha.',
    bookingTitle: 'Book Hadatha — Artist Booking',
    bookingDesc: 'Submit a booking inquiry for Hadatha for concerts, events, and performances.',
    pressTitle: 'Press Center — Hadatha',
    pressDesc: 'Official press releases, media mentions, and interviews for Hadatha.',
    epkTitle: 'Electronic Press Kit — Hadatha',
    epkDesc: 'Official EPK for Hadatha. Artist bio, music, videos, achievements, and booking information.',
    galleryTitle: 'Gallery — Hadatha',
    galleryDesc: 'Official photo gallery for Hadatha.',
    videosTitle: 'Videos — Hadatha',
    videosDesc: 'Official music videos and performance footage by Hadatha.',
    searchTitle: 'Search — Hadatha',
    searchDesc: 'Search music, news, events, videos, and press on the Hadatha platform.',
    fansTitle: 'Fan Zone — Hadatha',
    fansDesc: 'Join the Hadatha fan community. Create an account, save favorites, and stay connected.',
  },
};

const sw: typeof en = {
  nav: {
    home: 'Nyumbani',
    music: 'Muziki',
    videos: 'Video',
    gallery: 'Picha',
    events: 'Matukio',
    news: 'Habari',
    about: 'Kuhusu',
    booking: 'Hifadhi Sasa',
    press: 'Vyombo vya Habari',
    epk: 'EPK',
    search: 'Tafuta',
    fans: 'Mashabiki',
  },
  home: {
    heroTitle: 'HADATHA',
    heroSubtitle: 'Msanii wa Tanzania',
    heroCtaBook: 'Hifadhi Sasa',
    heroCtaMusic: 'Sikiliza Sasa',
    featuredReleases: 'Nyimbo Mpya',
    upcomingEvents: 'Matukio Yanayokuja',
    latestNews: 'Habari za Hivi Karibuni',
    streamOn: 'Sikiliza kwenye',
    viewAll: 'Tazama Zote',
    noEvents: 'Hakuna matukio yanayokuja kwa sasa.',
    noNews: 'Hakuna makala ya habari bado.',
  },
  about: {
    title: 'Kuhusu Hadatha',
    subtitle: 'Simba Jike Mweupe',
    bio: 'Wasifu wa Msanii',
    origin: 'Asili',
    genre: 'Aina ya Muziki',
    contact: 'Wasiliana Nasi',
  },
  music: {
    title: 'Muziki',
    subtitle: 'Nyimbo na Albamu',
    allReleases: 'Nyimbo Zote',
    singles: 'Nyimbo Moja',
    albums: 'Albamu',
    eps: 'EP',
    streamOn: 'Sikiliza kwenye',
    noMusic: 'Hakuna nyimbo bado.',
    listenOn: 'Sikiliza kwenye',
  },
  events: {
    title: 'Matukio',
    subtitle: 'Maonyesho ya Moja kwa Moja',
    upcoming: 'Yanayokuja',
    past: 'Matukio Yaliyopita',
    getTickets: 'Pata Tiketi',
    noUpcoming: 'Hakuna matukio yanayokuja kwa sasa.',
    noPast: 'Hakuna matukio yaliyopita.',
    venue: 'Mahali',
    date: 'Tarehe',
    time: 'Wakati',
  },
  news: {
    title: 'Habari',
    subtitle: 'Masasisho ya Hivi Karibuni',
    readMore: 'Soma Zaidi',
    noNews: 'Hakuna makala ya habari bado.',
    category: 'Kategoria',
    publishedOn: 'Imechapishwa tarehe',
    by: 'na',
  },
  booking: {
    title: 'Hifadhi Hadatha',
    subtitle: 'Wasilisha ombi la uhifadhi',
    name: 'Jina Kamili',
    email: 'Anwani ya Barua Pepe',
    phone: 'Nambari ya Simu',
    country: 'Nchi',
    eventType: 'Aina ya Tukio',
    eventDate: 'Tarehe ya Tukio',
    venue: 'Mahali',
    budget: 'Bajeti',
    message: 'Ujumbe',
    submit: 'Wasilisha Ombi',
    submitting: 'Inawasilisha...',
    success: 'Ombi lako la uhifadhi limewasilishwa. Tutawasiliana nawe ndani ya masaa 24.',
    error: 'Imeshindwa kuwasilisha. Tafadhali jaribu tena.',
    required: 'Sehemu hii inahitajika.',
    invalidEmail: 'Tafadhali ingiza anwani sahihi ya barua pepe.',
    guestCount: 'Idadi ya Wageni',
    accommodation: 'Malazi Inahitajika',
    transport: 'Usafiri Unahitajika',
    technicalReqs: 'Mahitaji ya Kiufundi',
    performanceDuration: 'Muda wa Onyesho',
  },
  contact: {
    title: 'Wasiliana',
    subtitle: 'Tuwasiliane',
    email: 'Barua Pepe',
    phone: 'Simu',
    forBookings: 'Kwa Uhifadhi',
    forPress: 'Kwa Vyombo vya Habari',
    sendMessage: 'Tuma Ujumbe',
    yourName: 'Jina Lako',
    yourEmail: 'Barua Pepe Yako',
    subject: 'Mada',
    yourMessage: 'Ujumbe Wako',
    send: 'Tuma',
    sending: 'Inatuma...',
    sent: 'Ujumbe umetumwa.',
    failed: 'Imeshindwa kutuma. Tafadhali jaribu tena.',
  },
  gallery: {
    title: 'Picha',
    subtitle: 'Picha na Vyombo vya Habari',
    all: 'Zote',
    noImages: 'Hakuna picha bado.',
  },
  videos: {
    title: 'Video',
    subtitle: 'Video za Muziki na Maonyesho',
    watchOn: 'Tazama kwenye YouTube',
    noVideos: 'Hakuna video bado.',
  },
  press: {
    title: 'Kituo cha Vyombo vya Habari',
    subtitle: 'Habari na Matangazo',
    pressReleases: 'Matangazo ya Habari',
    mediaCoverage: 'Habari za Vyombo',
    downloadPdf: 'Pakua PDF',
    readArticle: 'Soma Makala',
    pressInquiries: 'Maswali ya Vyombo vya Habari',
    noPress: 'Hakuna habari zilizochapishwa bado.',
  },
  epk: {
    title: 'Kifurushi cha Vyombo vya Habari',
    subtitle: 'EPK Rasmi',
    biography: 'Wasifu wa Msanii',
    shortBio: 'Wasifu Mfupi',
    music: 'Muziki',
    videos: 'Video',
    achievements: 'Mafanikio',
    pressQuotes: 'Manukuu ya Vyombo vya Habari',
    booking: 'Uhifadhi',
    streaming: 'Mitandao ya Muziki',
    downloadEpk: 'Pakua EPK (PDF)',
    notPublished: 'EPK haipatikani bado.',
  },
  fans: {
    title: 'Eneo la Mashabiki',
    subtitle: 'Jiunge na Jamii ya Hadatha',
    register: 'Fungua Akaunti',
    login: 'Ingia',
    logout: 'Toka',
    email: 'Anwani ya Barua Pepe',
    password: 'Nywira',
    displayName: 'Jina la Kuonyesha',
    confirmPassword: 'Thibitisha Nywira',
    alreadyHaveAccount: 'Una akaunti tayari?',
    noAccount: 'Huna akaunti?',
    favorites: 'Vipendwa Vyangu',
    noFavorites: 'Hakuna vipendwa bado.',
    welcome: 'Karibu',
    registerSuccess: 'Akaunti imeundwa.',
    loginSuccess: 'Umeingia.',
    logoutSuccess: 'Umetoka.',
  },
  footer: {
    contact: 'Wasiliana',
    email: 'info@hadathatz.com',
    phone: '+255 718 863 913',
    rights: 'Haki zote zimehifadhiwa.',
    newsletter: 'Jiandikishe kwa Jarida',
    newsletterPlaceholder: 'Anwani yako ya barua pepe',
    subscribe: 'Jiandikishe',
    quickLinks: 'Viungo vya Haraka',
    followUs: 'Tufuate',
    streamMusic: 'Sikiliza Muziki',
    privacyPolicy: 'Sera ya Faragha',
    terms: 'Masharti ya Matumizi',
  },
  search: {
    title: 'Tafuta',
    placeholder: 'Tafuta muziki, habari, matukio, video, vyombo vya habari...',
    button: 'Tafuta',
    noResults: 'Hakuna matokeo',
    results: 'matokeo ya',
    filters: {
      all: 'Yote',
      music: 'Muziki',
      news: 'Habari',
      events: 'Matukio',
      gallery: 'Picha',
      videos: 'Video',
      press: 'Vyombo vya Habari',
    },
  },
  common: {
    loading: 'Inapakia...',
    error: 'Kuna hitilafu.',
    readMore: 'Soma Zaidi',
    learnMore: 'Jifunze Zaidi',
    close: 'Funga',
    back: 'Rudi',
    next: 'Inayofuata',
    previous: 'Iliyotangulia',
    share: 'Shiriki',
    download: 'Pakua',
    publish: 'Chapisha',
    draft: 'Rasimu',
    published: 'Imechapishwa',
    save: 'Hifadhi',
    cancel: 'Ghairi',
    delete: 'Futa',
    edit: 'Hariri',
    create: 'Unda',
    update: 'Sasisha',
    viewAll: 'Tazama Zote',
    noData: 'Hakuna data.',
    required: 'Inahitajika',
    optional: 'Si lazima',
  },
  seo: {
    homeTitle: 'Hadatha — Jukwaa Rasmi la Msanii | Simba Jike Mweupe',
    homeDesc: 'Jukwaa rasmi la Hadatha (Ester Edson), msanii wa Afro & muziki wa kisasa wa Afrika Mashariki.',
    musicTitle: 'Muziki — Hadatha',
    musicDesc: 'Sikiliza na gundua muziki wa Hadatha kwenye Spotify, Apple Music, YouTube, na SoundCloud.',
    eventsTitle: 'Matukio — Hadatha',
    eventsDesc: 'Maonyesho ya moja kwa moja yanayokuja ya Hadatha.',
    newsTitle: 'Habari — Hadatha',
    newsDesc: 'Habari za hivi karibuni, masasisho, na matangazo kutoka Hadatha.',
    bookingTitle: 'Hifadhi Hadatha — Uhifadhi wa Msanii',
    bookingDesc: 'Wasilisha ombi la uhifadhi wa Hadatha kwa matamasha, matukio, na maonyesho.',
    pressTitle: 'Kituo cha Vyombo vya Habari — Hadatha',
    pressDesc: 'Matangazo rasmi ya habari, habari za vyombo, na mahojiano ya Hadatha.',
    epkTitle: 'Kifurushi cha Vyombo vya Habari — Hadatha',
    epkDesc: 'EPK rasmi ya Hadatha. Wasifu, muziki, video, mafanikio, na maelezo ya uhifadhi.',
    galleryTitle: 'Picha — Hadatha',
    galleryDesc: 'Picha rasmi za Hadatha.',
    videosTitle: 'Video — Hadatha',
    videosDesc: 'Video rasmi za muziki na maonyesho ya Hadatha.',
    searchTitle: 'Tafuta — Hadatha',
    searchDesc: 'Tafuta muziki, habari, matukio, video, na vyombo vya habari kwenye jukwaa la Hadatha.',
    fansTitle: 'Eneo la Mashabiki — Hadatha',
    fansDesc: 'Jiunge na jamii ya mashabiki wa Hadatha. Fungua akaunti, hifadhi vipendwa, na endelea kuunganika.',
  },
};

export function getTranslations(lang: Language) {
  return lang === 'sw' ? sw : en;
}
